import { throwError } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { EventColor } from 'calendar-utils';
export class Common {

    public static days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

    public static roles = ['ADMIN', 'FACULTY', 'STAFF'];

    public static gender = ['Male', 'Female', 'Others'];

    public static transport = ['Bus', 'Cab', 'Personal Vehicle', 'Others'];

    public static goingTo = ['Parent/Guardian Home - Local', 'Parent/Guardian Home - OutStation', 'Others - Trip/Excursion'];

    public static getToday() {
        return new Date();
    }

    public static urls: any = {
        room: {
            path: 'room_view',
            id_field: 'room_id',
        },
        faculty: {
            path: 'faculty_view',
            id_field: 'faculty_id',
        },
        course: {
            path: 'course_view',
            id_field: 'course_id',
        },
    };

    public static colors: Record<string, EventColor> = {
        red: {
            primary: '#ad2121',
            secondary: '#FAE3E3',
        },
        blue: {
            primary: '#1e90ff',
            secondary: '#D1E8FF',
        },
        yellow: {
            primary: '#e3bc08',
            secondary: '#FDF1BA',
        },
        green: {
            primary: '#13a613',
            secondary: '#0a910a',
        },
        orange: {
            primary: '#FF6600',
            secondary: '#b14904',
        },
        purple: {
            primary: '#6600FF',
            secondary: '#5005c1',
        },
    };

    public static httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
        }),
    };

    public static campusHeader(campusId: string = 'MAIN') {
        return { headers: new HttpHeaders({ 'X-Campus-Id': campusId }) };
    }

    public static handleError(error: any) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            // errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
            errorMessage = `Error Code: ${error.status}`;
        }
        // window.alert(errorMessage);
        return throwError(() => {
            return errorMessage;
        });
    }

    public static getRandomInt(max) {
        return Math.floor(Math.random() * max);
    }

    public static getRandomColour(type) {
        // let colour = ['red', 'blue', 'yellow'];
        // return colour[this.getRandomInt(5)];
        if (type == 'class') {
            return 'blue';
        } else {
            return 'yellow'
        }
    }

    public static getTitle(element: any, view: any) {
        if (view == 'month') {
            if (element.type == 'class') {
                return 'Room No : ' + element.room_no + ", " + "Course : " + element.course_name + ", " + "Faculty : " + element.faculty_name;
            } else {
                return 'Room No : ' + element.room_no + ", " + "Program : " + element.course_name + ", " + "Organised by : " + element.organised_by_name;
            }
        } else {
            if (element.type == 'class') {
                return 'Room No : ' + element.room_no + "</br>" + "Course : " + element.course_name + "</br>" + "Faculty : " + element.faculty_name;
            } else {
                return 'Room No : ' + element.room_no + "</br>" + "Program : " + element.course_name + "</br>" + "Organised by : " + element.organised_by_name;
            }
        }
    }

    public static convertDateFormat(date: Date) {
        const yyyy = date.getFullYear();
        let mm: any = date.getMonth() + 1;
        let dd: any = date.getDate();
        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;
        return dd + '-' + mm + '-' + yyyy;
    }

    public static getMonday(d) {
        d = new Date(d);
        var day = d.getDay(),
            diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
        return this.convertDateFormat(new Date(d.setDate(diff)));
    }

    public static getStartOfMonth(d) {
        d = new Date(d); // Convert the input into a Date object
        var startOfMonth = new Date(d.getFullYear(), d.getMonth(), 1); // Get the first day of the month
        return this.convertDateFormat(startOfMonth);
    }

    public static getDate(d) {
        return this.convertDateFormat(new Date(d));
    }

    public static b64toBlob(b64Data: any, contentType: any, filename: any) {
        contentType = contentType || '';
        let sliceSize = 512;
        var byteCharacters = atob(b64Data);
        var byteArrays = [];
        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        var blob = new Blob(byteArrays, { type: contentType });
        let a = document.createElement("a");
        document.body.appendChild(a);
        var url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = String(filename + ".pdf");
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
    }
}